<script setup lang="ts">
import { defineProps, defineEmits } from 'vue'

const props = defineProps<{
  parent: boolean
  expanded: boolean
  active: boolean
  label: string
  name: string
}>()

const emit = defineEmits<{
  (e: 'click'): void
  (e: 'toggle-parent'): void
}>()
</script>

<template>
  <div
    class="flyout-menu-item"
    :class="{ 'is-parent': props.parent, open: props.expanded, active: props.active }"
  >
    <button class="label" @click="$emit('click')">
      {{ props.label }}
    </button>

    <div
      v-if="props.parent"
      class="sub-arrow"
      @click.stop="$emit('toggle-parent')"
    >
      <i class="icon i i-mdi:chevron-right flex w-5 h-5" />
    </div>

    <transition name="flyout-expand-children">
      <div v-if="props.expanded" class="sec-sub-items">
        <slot />
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.flyout-menu-item {
  width: 100%;
  display: flex;
  align-items: center;

  position: relative;

  flex-direction: column;

  * {
    font-size: 14px;
  }

  button {
    width: 100%;
    

    padding: 1rem;
    border-bottom: 1px solid gainsboro;

    &:hover {
      background: var(--base-100);
      transform: translateY(-1px);
      &:active {
        transform: translateY(0);
      }
    }

    &:focus {
      outline: 0;
    }
  }
  .sec-sub-items {
    width: 100%;
  }
  > .sub-arrow {
    display: none;
  }

  &.is-parent {
    > .sub-arrow {
      position: absolute;
      right: 0;
      top: 23px;
      transform: translate(0, -50%);
      padding: 0;
      width: gr(1);
      height: gr(1);
      display: flex;
      align-items: center;
      background: none;
      border: none;

      > i {
        display: flex;
        font-size: fs(0);

        color: var(--base-500);

        transition: all 0.15s ease;
      }
    }

    .flyout-menu-item {
      background: #f6f6f6;
    }

    &.open {
      > .sub-arrow {
        > i {
          transform: rotate(90deg);
        }
      }
    }
  }

  &.open {
    &.is-parent {
      > .sub-arrow {
        > i {
          transform: rotate(90deg);
        }
      }
    }
  }

  &.active {
    > .label {
      color: var(--primary);
      font-weight: bold;
    }
  }
}
</style>
